import { EmployerUser } from '~/types';
import { patchData, postData } from '../../../utils/service';
import { ViewContext } from './types';

interface ApiProps<T> {
  input: {
    context: ViewContext;
    event: T;
  };
}

export const API_CALLS = {
  updateEmployer: async ({ input }: ApiProps<{ type: 'ON_NEXT_PAGE' }>) => {
    return await patchData('employerUser', {
      data: input.context.employer,
      pathParams: { employer_user_id: input.context.employerUser?.id?.toString() || '' },
    });
  },
  createRole: async ({ input }: ApiProps<{ type: 'ON_NEXT_PAGE' }>) => {
    return await postData('user', {
      data: {
        userId: input.context.userInfoId,
        roleCode: 'EMPLOYER',
      },
    });
  },
};

/**
 * Create user role
 */
export const createUserRole = async (
  userInfoId: number
): Promise<{ userId: number; roleCode: string }> => {
  const payload = {
    userId: userInfoId,
    roleCode: 'EMPLOYER',
  };

  return postData<{ userId: number; roleCode: string }>('userRole', {
    data: payload,
  });
};

interface CreateReq {
  userInfoId: number;
}

/**
 * Create Provider
 */
export const createEmployer = async (data: CreateReq): Promise<Partial<EmployerUser>> => {
  const payload = {
    userInfoId: data.userInfoId,
  };
  return postData<Partial<EmployerUser>>('employerUser', {
    data: payload,
  });
};

export interface BypassApprovalData {
  userInfoId: number;
  email: string;
  tosAccepted: boolean;
  legalEntityName: string;
  employerEin?: string;
  employerNpi?: string;
  employerType: string;
  ownershipStructure: string;
  employerWebsite: string;
  facilityName: string;
  facilityId?: string;
  facilityNpi?: string;
  clinicalSettingCategory: string;
  clinicalSetting: string;
  facilitySize: string;
  areaType: string;
}

export const bypassApprovalAndCreateEmployer = async (
  data: BypassApprovalData
): Promise<{
  employerUserId: number;
  employerId: number;
}> => {
  const payload = {
    userInfoId: data.userInfoId,
    email: data.email,
    tosAccepted: data.tosAccepted,
    legalEntityName: data.legalEntityName,
    employerEin: data.employerEin || undefined,
    employerNpi: data.employerNpi || undefined,
    employerType: data.employerType,
    ownershipStructure: data.ownershipStructure,
    employerWebsite: data.employerWebsite,
    facilityName: data.facilityName,
    facilityId: data.facilityId || undefined,
    facilityNpi: data.facilityNpi || undefined,
    clinicalSettingCategory: data.clinicalSettingCategory,
    clinicalSetting: data.clinicalSetting,
    facilitySize: data.facilitySize,
    areaType: data.areaType,
  };
  return postData<{ employerUserId: number; employerId: number }>('newEmployerUserRegistration', {
    data: payload,
  });
};
